import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import ChartTypes from "@/components/ChartTypes.tsx";
import DashboardDataGenerator from "../../DashboardDataGenerator";

@Component
export default class ReadingFeedbackMain extends Vue {
  @Prop({ default: null }) studentId!: string;
  private sections: any;
  private color = ["red", "green", "#FFA500"];

  created() {
    this.sections = [];
  }

  stateLoaded() {
    let skills = this.$store.getters.studentDashboard.bala.descriptions.skills;
    if (!skills) return false;

    let feedback = Object.keys(skills);
    if (feedback) {
      if (this.sections.length == 0) {
        feedback.forEach((item: any) => {
          this.sections.push({ selected: false, ...skills[item] });
        });
      }
      return true;
    }
    return false;
  }

  render(h: CreateElement) {
    return (
      this.stateLoaded() && (
        <v-card>
          <v-card-title
            class="mx-auto text-center"
            style={{ paddingBottom: 0 }}
          >
            <span>Feedback</span>
          </v-card-title>
          <v-card-text>
            <p>
              Here are some tips that might help you get better at your 3
              reading skills:
            </p>
            <v-list>
              {this.sections.map((item: any, i: number) => (
                <span>
                  <v-list-item
                    onClick={() => {
                      this.sections[i].selected = !this.sections[i].selected;
                      this.$forceUpdate();
                    }}
                    color={this.color[i]}
                    style={{ backgroundColor: "#FBFBFB", marginBottom: "5px" }}
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        <span>{item.name}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-dialog
                    v-model={this.sections[i].selected}
                    content-class="cardDialog"
                  >
                    <Card
                      title={this.sections[i].name}
                      titleType="toolbar"
                      titleColor={this.sections[i].color}
                    >
                      <div slot="mainContent">
                        <p>{this.sections[i].description}</p>
                        Here are some tips that might help you get better at{" "}
                        {this.sections[i].name}:
                        <v-list>
                          {this.sections[i]["improve"].map((item: string) => (
                            <v-list-item>- {item}</v-list-item>
                          ))}
                        </v-list>
                      </div>
                      <div slot="actions">
                        <v-btn
                          onClick={() => {
                            this.sections[i].selected = false;
                            this.$forceUpdate();
                          }}
                        >
                          Close
                        </v-btn>
                      </div>
                    </Card>
                  </v-dialog>
                </span>
              ))}
            </v-list>
          </v-card-text>
        </v-card>
      )
    );
  }
}

const component = ReadingFeedbackMain;
